<div class="dashboard-card card">
  <div class="card-body dashboard-card-content">
    <div class="card-title">
      <span class="title" translate>FILTERABLE_SALES_INFORMATION</span>
    </div>
    <lib-filter-list [configService]="filterCardService"></lib-filter-list>
  </div>
</div>
